import { ReactNode } from 'react';
import { RadioWrapper, RadioWrapperProps } from '../../../radio/RadioWrapper';

export function TemplateFormRadioWrapper({
  options,
  fieldName
}: {
  options: RadioWrapperProps[];
  fieldName: string;
}): ReactNode {
  const dataId = `template-form-${fieldName}-radio-wrapper`;

  return (
    <>
      {options.map(radio => (
        <RadioWrapper key={`${dataId}-${radio.radioProps.value}`} {...radio} dataId={dataId}>
          {radio.children ? radio.children : null}
        </RadioWrapper>
      ))}
    </>
  );
}
